import {
  getMidPoint,
  getPointOnTheLine,
} from "../../../helpers/sqftHelper";
import COLOR_THEMES from "../../../../../colorThemes";
import sqftConfig from "../store/sqftConfig";

export default class RenderCabinets {

  /**
   * @param points {[{x:int, y:int}]}
   * @param distance {int}
   * @return {[DiagonalPointsForTheSquareInterface]}
   */
  static getDiagonalPointsForTheSquare = (points, distance) => {
    let returnPoints = [];
    for (const pointIndex in points) {
      if (points.hasOwnProperty(pointIndex)) {
        const len = points.length;
        const current = points[+pointIndex];
        const previous = points[(+pointIndex + len - 1) % len];
        const next = points[(+pointIndex + 1) % len];

        const linePoint1 = getPointOnTheLine(current, previous, distance);
        const linePoint2 = getPointOnTheLine(current, next, distance);
        const diagonalPoint = getMidPoint(linePoint1, linePoint2);

        returnPoints.push({
          currentPoint: current,
          diagonalPoint: diagonalPoint
        });
      }
    }

    return returnPoints
  }

  /**
   * @param points {[{x:int, y:int}]}
   * @param distance {int}
   * @param linePointsIds {[]}
   * @return {[DiagonalPointsForTheSquareInterface]}
   */
  static getDiagonalPointsForTheLine = (points, distance, linePointsIds) => {
    const diagonalSquarePoint = RenderCabinets.getDiagonalPointsForTheSquare(points, distance);

    return diagonalSquarePoint.filter(squarePoint => {
      return linePointsIds.some(linePointId => {
        return linePointId === squarePoint.currentPoint.id
      });
    })
  }

  static renderCrownMolding = (
    ctx,
    crownMoldingPoints,
    opts = {
      stroke: true,
      fill: false,
      strokeStyle: '#000',
      fillStyle: 'rgba(0,0,0,0.2)',
      lineWidth: 2,
    }
  ) => {
    const {
      stroke = true,
      fill = false,
      strokeStyle = '#000',
      fillStyle = 'rgba(0,0,0,0.2)',
      lineWidth = 2,
    } = opts;

    ctx.save();

    // --- Build a single simple polygon: diagonal polyline forward + current polyline backward ---
    if (fill) {
      const n = crownMoldingPoints.length;
      if (n >= 2) {
        ctx.beginPath();

        // 1) Start on the first diagonal point and walk along all diagonal points (top edge)
        ctx.moveTo(
          crownMoldingPoints[0].diagonalPoint.x,
          crownMoldingPoints[0].diagonalPoint.y
        );
        for (let i = 1; i < n; i++) {
          const p = crownMoldingPoints[i].diagonalPoint;
          ctx.lineTo(p.x, p.y);
        }

        // 2) Come back along the "current" points in reverse (bottom edge of the strip)
        for (let i = n - 1; i >= 0; i--) {
          const p = crownMoldingPoints[i].currentPoint;
          ctx.lineTo(p.x, p.y);
        }

        ctx.closePath();
        ctx.fillStyle = fillStyle;     // ensure the intended fill color is applied
        ctx.fill();                    // simple fill rule is enough for a single contour
      }
    }

    // --- Draw outlines on top (visual ribs + top ring) ---
    if (stroke) {
      ctx.strokeStyle = strokeStyle;
      ctx.lineWidth = lineWidth;

      // Top diagonal ring
      ctx.beginPath();
      ctx.moveTo(
        crownMoldingPoints[0].diagonalPoint.x,
        crownMoldingPoints[0].diagonalPoint.y
      );
      for (let i = 1; i < crownMoldingPoints.length; i++) {
        const p = crownMoldingPoints[i].diagonalPoint;
        ctx.lineTo(p.x, p.y);
      }
      ctx.closePath();
      ctx.stroke();

      // Vertical ribs: from current -> diagonal
      for (const p of crownMoldingPoints) {
        ctx.beginPath();
        ctx.moveTo(p.currentPoint.x,  p.currentPoint.y);
        ctx.lineTo(p.diagonalPoint.x, p.diagonalPoint.y);
        ctx.stroke();
      }
    }

    ctx.restore();
  };

  static renderEndCap = (ctx, line) => {
    //render thick line
    const fromPointField = line.from.getPointField();
    const toPointField = line.to.getPointField();
    ctx.beginPath();
    ctx.moveTo(fromPointField.x, fromPointField.y);
    ctx.lineWidth = 6;
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_hover;
    ctx.lineTo(toPointField.x, toPointField.y);
    ctx.stroke();
    ctx.closePath();
  }
}
